import { replaceString, lengthWithoutSpaces, createString } from './strings';
import { applyMask } from './mask';

import * as amexBrand from '@/assets/images/card/brands/american.svg';
import * as eloBrand from '@/assets/images/card/brands/elo.svg';
import * as visaBrand from '@/assets/images/card/brands/visa.svg';
import * as mastercardBrand from '@/assets/images/card/brands/mastercard.svg';
import * as hipercardBrand from '@/assets/images/card/brands/hipercard.svg';

import * as amexBrandWhite from '@/assets/images/card/brands/amex-white.svg';
import * as eloBrandWhite from '@/assets/images/card/brands/elo-white.svg';
import * as visaBrandWhite from '@/assets/images/card/brands/visa-white.svg';
import * as mastercardBrandWhite from '@/assets/images/card/brands/mastercard-white.svg';
import * as hipercardBrandWhite from '@/assets/images/card/brands/hipercard-white.svg';

export const cardBrandByBrandName = (brand: string, white: boolean = false): string => {
  if (brand === 'amex' || brand === 'american_express') return white ? amexBrandWhite : amexBrand;
  if (brand === 'elo') return white ? eloBrandWhite : eloBrand;
  if (brand === 'visa') return white ? visaBrandWhite : visaBrand;
  if (brand === 'mastercard') return white ? mastercardBrandWhite : mastercardBrand;
  if (brand === 'hipercard' || brand === 'hiper') return white ? hipercardBrandWhite : hipercardBrand;
  return '';
};

export const cardCVVMaskByBrand = (brand?: string|null): string => {
  if (brand === 'amex') {
    return '####';
  }

  return '###';
};

export const cardNumberMaskByBrand = (brand?: string|null, digits?: number|null): string => {
  if (brand === 'visa') {
    if (digits === 15) {
      return '#### ### ### ####';
    }
  }

  if (brand === 'amex') {
    return '#### ###### #####';
  }

  return '#### #### #### ####';
};

export const applyCardMaskByBrand = (brand: string, digits: string, secretChar?: string): string => {
  if (secretChar) {
    digits = replaceString(digits, secretChar, '');
  }

  const size = lengthWithoutSpaces(digits);
  const lastDigits = digits.substring(size - 4, size);

  const mask = cardNumberMaskByBrand(brand);
  const maskSize = lengthWithoutSpaces(mask);

  if (secretChar) {
    const secretDigts = createString(maskSize - 4, secretChar);
    const cardNumber = secretDigts + lastDigits;

    digits = replaceString(cardNumber, secretChar, 'z');
  }

  const cardNumberWithMask = applyMask(digits, replaceString(mask, '#', 'n'));

  return (!secretChar)
    ? cardNumberWithMask
    : replaceString(cardNumberWithMask, 'z', secretChar);
};
